import WDBox from "../../../../../MaterialComponents/WDBox";
import WDTypography from "../../../../../MaterialComponents/WDTypography";
import { useEffect, useState } from "react";
import AppService from "../../../../../Configurations/Appservice";
import { Link, CircularProgress, Icon, Box } from "@mui/material";
import WDButton from "../../../../../MaterialComponents/WDButton";
import pxToRem from "../../../../../Themes/Functions/pxToRem";

const FileField = ({ field, onFileUpload, index, onFileRemove }) => {
  const [file, setFile] = useState();
  const [isFileUploading, fileUploading] = useState(false);

  const onFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  useEffect(() => {
    if (file) {
      fileUpload();
    }
  }, [file]);

  const fileUpload = () => {
    fileUploading(true);
    const formData = new FormData();

    formData.append("file", file);
    AppService.post("v1/files/upload", formData)
      .then((response) => {
        onFileUpload(response, field, index);
      })
      .catch((error) => {
        setFile();
      })
      .finally(() => {
        fileUploading(false);
      });
  };

  const _renderActionButton = () => {
    if (isFileUploading) {
      return <CircularProgress size={16} />;
    }
    if (!field.value) {
      return null;
    }
    return (
      <Icon fontSize="small" onClick={() => onFileRemove(field, index)}>
        delete
      </Icon>
    );
  };

  const _renderFileArea = () => {
    if (field.value) {
      return (
        <WDButton
          variant="text"
          component={Link}
          style={{ fontSize: "10px" }}
          target="_blank"
          href={field.value}
          underline="hover"
        >
          View uploaded {field.type}
        </WDButton>
      );
    }

    let acceptedType = "image/*";
    if (field.type == "PDF") {
      acceptedType = "application/pdf";
    } else if (field.type == "DOCUMENT") {
      acceptedType =
        ".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    }

    // accept="application/pdf
    return (
      <WDButton variant="text" component="label" style={{ fontSize: "10px" }}>
        {file ? file.name : `Select ${field.type}`}
        <input type="file" hidden onChange={onFileChange} accept={acceptedType} />
      </WDButton>
    );
  };

  return (
    <Box>
      <WDTypography
        variant="caption"
        sx={{ color: field.mandatory && !field.value ? "red" : null }}
      >
        {field.title}&nbsp;{field.mandatory ? "*" : ""}
      </WDTypography>
      <WDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        p={1}
        sx={{
          border: 1,
          borderColor: "grey.400",
          borderRadius: pxToRem(6),
          height: pxToRem(45),
        }}
      >
        {_renderFileArea()}
        {_renderActionButton()}
      </WDBox>
    </Box>
  );
};

export default FileField;
